export default "__VITE_ASSET__CA_s6H9u__"